<template>
  <unauthorised v-if="!loading && !isAuthorised" />
  <the-navigation v-else-if="route.meta.showNavigation">
    <router-view />
  </the-navigation>
  <router-view v-else />
  <the-inactivity-timer />
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import useLoginData from '@/common/composition/useLoginData';
import TheNavigation from '@/areas/skeleton/views/TheNavigation.vue';
import Unauthorised from '@/router/Unauthorised.vue';
import { route } from '@/plugins/router';
import TheInactivityTimer from '@/common/components/zvdzo/TheInactivityTimer.vue';

const { autorisatieData, loading } = useLoginData();

const isAuthorised = computed<boolean | undefined>(() => {
  if (!route.value.meta.mustBeLoggedIn) {
    return true;
  }
  if (!autorisatieData.value) {
    return undefined;
  }
  return route.value.meta.isAuthorised(autorisatieData.value) || false;
});
</script>
